import React, { useContext, ReactElement, HTMLAttributes, forwardRef, CSSProperties } from 'react';
import { getPlatformStyles, isDesktop } from '@direct-frontend/platform-code';

import { TestProps } from '../../../internal/types/testTypes';
import { addRootNodeClassName, cn } from '../../../lib/css/className/className';
import { ListContext } from '../utils';
import { getSizeSkin } from '../../../lib/skin/getSizeSkin/getSizeSkin';
import { getColorSkin } from '../../../lib/skin/getColorSkin/getColorSkin';

getPlatformStyles({
    common: import('./ListBaseItem.css'),
    mobile: import('./ListBaseItem@mobile.css'),
});

const cls = cn('ListBaseItem');

export interface ListBaseItemProps extends TestProps, Pick<HTMLAttributes<HTMLLIElement>, 'role'> {
    /**
     * Содержимое элемента
     */
    children: ReactElement<{ className: string }>;

    /**
     * Названия классов для элемента
     */
    className?: string;

    /**
     * Флаг отключенности элемента.
     */
    isDisabled?: boolean;

    /**
     * Стили для использования drag and drop
     */
    draggableStyle?: CSSProperties;
}

export const ListBaseItem = forwardRef<HTMLLIElement, ListBaseItemProps>(function ListBaseItem(
    props: ListBaseItemProps,
    ref,
) {
    const { 'data-testid': dataTestId, isDisabled, children, className, role, draggableStyle } = props;
    const { size } = useContext(ListContext);
    const sizeSkinClass = getSizeSkin(size);
    const colorSkinClass = getColorSkin(isDesktop() ? 'gray-transparent' : 'gray-neutral', {});

    return (
        <li
            aria-disabled={isDisabled}
            className={cls({ size }, [sizeSkinClass, colorSkinClass, className])}
            data-testid={dataTestId}
            role={role}
            ref={ref}
            style={draggableStyle}
        >
            {addRootNodeClassName(children, cls('content'))}
        </li>
    );
});
